import { MessageCircle } from "lucide-react";
import { LeadForm } from "@/components/kit/LeadForm";
import { MaskLines, Reveal } from "@/components/site/Motion";
import { LeafCutout } from "@/components/kit/Decor";
import { SITE, waLink } from "@/lib/content";

export function ClosingBook({ idPrefix = "book" }: { idPrefix?: string }) {
  return (
    <section id="book" data-testid="closing-cta-section" className="grain relative overflow-hidden bg-forest py-24 text-cream sm:py-32">
      <LeafCutout variant="a" className="-left-20 bottom-0 h-72 w-60 opacity-70" speed={0.06} flip />
      <div className="wrap relative grid gap-14 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-6">
          <p className="eyebrow-dark">Your first step</p>
          <h2 className="mt-6 text-5xl leading-[0.98] sm:text-6xl lg:text-7xl">
            <MaskLines lines={["Start with a", <em key="c" className="text-gold-soft">conversation,</em>, "not a payment."]} />
          </h2>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-md text-base leading-relaxed text-cream/85">Share a few details and Sony will call you for a free 20-minute consultation. If the programme isn't right for you, he'll tell you honestly.</p>
            <a href={waLink()} target="_blank" rel="noreferrer" className="btn-cream mt-8" data-testid={`${idPrefix}-cta-whatsapp`}>
              <MessageCircle className="h-4 w-4" /> Prefer WhatsApp? {SITE.phoneDisplay}
            </a>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-6"><LeadForm idPrefix={idPrefix} /></Reveal>
      </div>
    </section>
  );
}
